import { BTC_ID, ETH_ID, ICP_ICP_ID, SOL_ID } from '../constants/tokenIds'
import { useUserTokens } from '../state'

export const addDefaultWalletTokens = (principalId: string) => {
  const { addToken } = useUserTokens.getState()

  addToken(principalId, ICP_ICP_ID)
  addToken(principalId, SOL_ID)
  addToken(principalId, ETH_ID)
  addToken(principalId, BTC_ID)
}
